<template>
	<div class="app_content">
		<h1 v-if="showStepHeader" class="content_header">
			{{ currentStepHeader }}
		</h1>
		<div class="form_wrap">
			<intro v-if="currentStep === 0" />
			<form-box :product="product"
					  :step="currentStep"
					  :appName="appName"
					  :currentStepHeader="currentStepHeader"
					  :circleNavData="circleNavData"
					  :fullName="
          application.clientInfo.Applicant_First_Name +
            ' ' +
            application.clientInfo.Applicant_Last_Name
        "
					  v-on:sendDataToApp="saveDataToApp"
					  v-on:changeLvr="changeLvr"
					  v-on:stepValid="stepValid"
					  v-on:updateClientInfo="updateClientInfo"
					  v-on:updateFarmInfo="updateFarmInfo"
					  v-on:updateFinanceInfo="updateFinanceInfo"
					  v-on:saveLoanData="saveLoanData"
					  v-on:sendDataToAPI="sendDataToAPI"
					  v-on:setGuid="setGuid"
					  v-on:stepBack="stepBack"
					  v-on:stepNext="stepNext" />
			<buttons-box :step="currentStep"
						 :exitUrl="exitUrl"
						 :nextButtonEnabled="nextButtonEnabled"
						 v-on:stepBack="stepBack"
						 v-on:stepNext="stepNext"
						 v-on:checkEligibility="checkEligibility"
						 v-on:submitApplication="submitApplication" />
			<loader v-if="loading" />
		</div>
	</div>
</template>

<script>
	import libraryMixin from "./library_mixin";
	import Intro from "@/components/Intro.vue";
	import FormBox from "@/components/FormBox.vue";
	import ButtonsBox from "@/components/ButtonsBox.vue";
	import Loader from "@/components/Loader.vue";

	export default {
		mixins: [libraryMixin],
		components: {
			intro: Intro,
			formBox: FormBox,
			buttonsBox: ButtonsBox,
			loader: Loader,
		},
		props: ['product', 'exitUrl'],
		data: function data() {
			return {
				saveDataRequests: [],
				guid: null,
				api_url: "",
				loading: false,
				flow: [
					{
						header: "Let's check your eligibility",
						valid: false,
					},
					{
						header: "Let's check your eligibility",
						valid: false,
					},
					{
						header: "Farm details",
						valid: false,
					},
					{
						header: "Finance details",
						valid: false,
					},
					{
						header: "Your details",
						valid: false,
					},
					{
						header: "Thank you for applying",
						valid: false,
					},
					{
						header: "We need a bit more information",
						valid: false,
					},
					{
						header: "Great news!",
						valid: false,
					},
					{
						header: "Great news!",
						valid: false,
					},
				],
				currentStep: 0,
				application: {
					product: "beef", //new field
					purpose: "buy",
					interestRate: null,  //set in step 0
					owner_type: "trust",
					operator_type: "trust",
					farm_type: "beef",
					clientInfo: {
						Applicant_Address_Details: {},
						Applicant2_Address_Details: {},
					},
					loanData: {},
					farmInfo: {
						Farm_Address_Details: {},
						NewFarm_Address_Details: {},
					},
					financeInfo: {},
				},
				lvr: 0,
				eligibility: null,
				call_headers: { "Content-type": "application/json; charset=UTF-8" },
				queryString: "",
			};
		},
		computed: {
			currentStepHeader: function currentStepHeader() {
				return this.flow[this.currentStep].header;
			},
			//#pjw
			appName: function appName() {
				return this.product === "dairy"
					? "Dairy Direct"
					: "Sheep & Beef Direct";
			},
			nextButtonEnabled: function nextButtonEnabled() {
				var self = this;
				var has_invalid_steps = this.flow.find(function (el, index) {
					return index <= self.currentStep && !el.valid;
				});
				return !has_invalid_steps;
			},
			showStepHeader: function showStepHeader() {
				const steps_with_header = [0, 1, 5, 6, 7, 8];
				return steps_with_header.indexOf(this.currentStep) > -1;
			},
			circleNavData: function circleNavData() {
				return [this.flow[2].valid, this.flow[3].valid, this.flow[4].valid];
			},
		},
		watch: {
			currentStep: function (val) {
				this.$emit("step_changed", val);
				this.sendPageTrackingData(val);
			},
			$route(to, from) {
				if (
					this.currentStep === 1 &&
					from.name === "check-eligibility" &&
					to.name === "farm-details"
				) {
					this.checkEligibility();
				} else {
					switch (to.name) {
						case "check-eligibility":
							this.currentStep = 1;
							break;
						case "farm-details":
							this.currentStep = 2;
							break;
						case "finance-details":
							this.currentStep = 3;
							break;
						case "your-details":
							this.currentStep = 4;
							break;
						case "declined":
						case "dd-declined":
							this.currentStep = 5;
							break;
						case "referred":
						case "dd-referred":
							this.currentStep = 6;
							break;
						case "success":
						case "dd-success":
							this.currentStep = 7;
							break;
						case "approved":
						case "dd-approved":
							this.currentStep = 8;
							break;
						default:
							this.currentStep = 0;
					}
				}
			},
		},
		methods: {
			saveDataToApp: function saveDataToApp(obj) {
				if (!obj || !obj.property) {
					return false;
				}
				let value_to_save = obj.value ? obj.value : null;
				if (typeof this.application[obj.property] !== "undefined") {
					this.application[obj.property] = value_to_save;
				}
			},
			changeLvr: function changeLvr(val) {
				this.lvr = val;
			},
			updateClientInfo: function updateClientInfo(obj) {
				this.application.clientInfo = Object.assign(
					this.application.clientInfo,
					obj
				);
			},
			updateFarmInfo: function updateFarmInfo(obj) {
				this.application.farmInfo = obj;
			},
			updateFinanceInfo: function updateFinanceInfo(obj) {
				this.application.financeInfo = obj;
			},
			saveLoanData: function saveLoanData(obj) {
				this.application.loanData = obj;
				if (this.guid) {
					this.debouncedSendDataToAPI();
				}
			},
			stepValid: function stepValid(obj) {
				this.flow[obj.step].valid = obj.valid;
			},
			stepBack: function stepBack(step) {
				if (this.currentStep > 0) {
					this.currentStep = this.currentStep - 1;
					window.scrollTo(0, 0);
				}
			},
			stepNext: function stepNext(step) {
				if (this.currentStep === 0) {
					this.currentStep = 1;
					window.scrollTo(0, 0);
				} else if (this.currentStep === 1) {
					console.log(1, window);
					window.scrollTo(0, 0);
					this.debouncedSendDataToAPI();
				} else if (this.currentStep > 1) {
					window.scrollTo(0, 0);
					this.debouncedSendDataToAPI();
					this.currentStep += 1;
				}
			},
			setGuid: function setGuid() {
				if (!this.guid) {
					fetch(this.api_url, {
						method: "POST",
						body: JSON.stringify({ Query_String: this.queryString }),
						headers: this.call_headers,
					})
						.then((response) => {
							if (response.ok) {
								return response.json();
							}
							return Promise.reject(response);
						})
						.then((data) => {
							if (data.Data && data.Data.Guid) {
								this.guid = data.Data.Guid;
								if (this.application.clientInfo.Privacy_Declaration) {
									this.debouncedSendDataToAPI();
								}
							}
						})
						.catch(function (error) {
							console.warn("Something went wrong.", error);
						});
				}
			},
			sendDataToAPI: function sendDataToAPI() {
				if (!this.guid) return false;
				var data_to_send = {
					guid: this.guid,
					Product: this.appName,
					Loan_type:
						this.application && this.application.purpose
							? this.application.purpose
							: "buy",
					Farm_Purchase_Price: this.application.loanData.Farm_Purchase_Price,
					Deposit_Amount: this.application.loanData.Deposit_Amount,
					Farm_Worth: this.application.loanData.Farm_Worth,
					Farm_Refinance_Amount: this.application.loanData.Farm_Refinance_Amount,
					Working_Capital: this.application.loanData.Working_Capital === "Yes",
					Working_Capital_Amount: this.application.loanData
						.Working_Capital_Amount,
					Privacy_Declaration: this.application.clientInfo.Privacy_Declaration,
					Accepted_Marketing_Communication: this.application.clientInfo
						.Accepted_Marketing_Communication,
					Farm_Address_Text: this.application.farmInfo.Farm_Address_Text,
					NewFarm_Address_Text: this.application.farmInfo.NewFarm_Address_Text,
					Farm_Bigger_50: this.application.farmInfo.Farm_Bigger_50,
					Farm_Has_Consents: this.application.farmInfo.Farm_Has_Consents, //#pjw
					Farm_Operation_Type: this.application.farm_type,
					Farm_Owner_Name: this.application.farmInfo.Farm_Owner_Name,
					Farm_Owner_Type: this.application.owner_type,
					Same_Operating_Entity: this.application.farmInfo
						.sameEntityOperatesTheFarm,
					Farm_Operator_Name: this.application.farmInfo.sameEntityOperatesTheFarm
						? null
						: this.application.farmInfo.Farm_Operator_Name,
					Farm_Operator_Type: this.application.farmInfo.sameEntityOperatesTheFarm
						? null
						: this.application.operator_type,
					Applicant_Autorized: this.application.farmInfo.Applicant_Autorized,
					Authorised_Credit_Check: this.application.farmInfo
						.Authorised_Credit_Check,
					Farm_Income: this.application.financeInfo.Farm_Income,
					Farm_Cost: this.application.financeInfo.Farm_Cost,
					Farm_Owner_Drawings: this.application.financeInfo.Farm_Owner_Drawings,
					Additional_Details: this.application.financeInfo.Additional_Details,
					Farm_Unit_Number: this.application.farmInfo.Farm_Address_Details
						.structured_address
						? this.application.farmInfo.Farm_Address_Details.structured_address
							.unit
						: null,
					Farm_Street_Number: this.application.farmInfo.Farm_Address_Details
						.structured_address
						? this.application.farmInfo.Farm_Address_Details.structured_address
							.street_number
						: null,
					Farm_Situation_Number: this.application.farmInfo.Farm_Address_Details
						.structured_address
						? this.application.farmInfo.Farm_Address_Details.structured_address
							.situation_number
						: null,
					Farm_Street_Name: this.application.farmInfo.Farm_Address_Details
						.structured_address
						? this.application.farmInfo.Farm_Address_Details.structured_address
							.street_name
						: null,
					Farm_Street_Type: this.application.farmInfo.Farm_Address_Details
						.structured_address
						? this.application.farmInfo.Farm_Address_Details.structured_address
							.road_type
						: null,
					Farm_Suburb: this.application.farmInfo.Farm_Address_Details
						.structured_address
						? this.application.farmInfo.Farm_Address_Details.structured_address
							.suburb
						: null,
					Farm_Town: this.getTown("farmInfo", "Farm_Address_Details"),
					Farm_Region: this.application.farmInfo.Farm_Address_Details
						.structured_address
						? this.application.farmInfo.Farm_Address_Details.structured_address
							.region
						: null,
					Farm_Postal_Code: this.application.farmInfo.Farm_Address_Details
						.structured_address
						? this.application.farmInfo.Farm_Address_Details.structured_address
							.postcode
						: null,
					Farm_Country: this.application.farmInfo.Farm_Address_Details
						.structured_address
						? this.application.farmInfo.Farm_Address_Details.structured_address
							.country
						: null,
					Farm_Address_Latitude: this.application.farmInfo.Farm_Address_Details
						.location
						? this.application.farmInfo.Farm_Address_Details.location.wgs84_lat
						: null,
					Farm_Address_Longitude: this.application.farmInfo.Farm_Address_Details
						.location
						? this.application.farmInfo.Farm_Address_Details.location.wgs84_lon
						: null,
					NewFarm_Unit_Number: this.application.farmInfo.NewFarm_Address_Details
						.structured_address
						? this.application.farmInfo.NewFarm_Address_Details.structured_address
							.unit
						: null,
					NewFarm_Street_Number: this.application.farmInfo.NewFarm_Address_Details
						.structured_address
						? this.application.farmInfo.NewFarm_Address_Details.structured_address
							.street_number
						: null,
					NewFarm_Situation_Number: this.application.farmInfo
						.NewFarm_Address_Details.structured_address
						? this.application.farmInfo.NewFarm_Address_Details.structured_address
							.situation_number
						: null,
					NewFarm_Street_Name: this.application.farmInfo.NewFarm_Address_Details
						.structured_address
						? this.application.farmInfo.NewFarm_Address_Details.structured_address
							.street_name
						: null,
					NewFarm_Street_Type: this.application.farmInfo.NewFarm_Address_Details
						.structured_address
						? this.application.farmInfo.NewFarm_Address_Details.structured_address
							.road_type
						: null,
					NewFarm_Suburb: this.application.farmInfo.NewFarm_Address_Details
						.structured_address
						? this.application.farmInfo.NewFarm_Address_Details.structured_address
							.suburb
						: null,
					NewFarm_Town: this.getTown("farmInfo", "NewFarm_Address_Details"),
					NewFarm_Region: this.application.farmInfo.NewFarm_Address_Details
						.structured_address
						? this.application.farmInfo.NewFarm_Address_Details.structured_address
							.region
						: null,
					NewFarm_Postal_Code: this.application.farmInfo.NewFarm_Address_Details
						.structured_address
						? this.application.farmInfo.NewFarm_Address_Details.structured_address
							.postcode
						: null,
					NewFarm_Country: this.application.farmInfo.NewFarm_Address_Details
						.structured_address
						? this.application.farmInfo.NewFarm_Address_Details.structured_address
							.country
						: null,
					NewFarm_Address_Latitude: this.application.farmInfo
						.NewFarm_Address_Details.location
						? this.application.farmInfo.NewFarm_Address_Details.location.wgs84_lat
						: null,
					NewFarm_Address_Longitude: this.application.farmInfo
						.NewFarm_Address_Details.location
						? this.application.farmInfo.NewFarm_Address_Details.location.wgs84_lon
						: null,
					Applicant_First_Name: this.application.clientInfo.Applicant_First_Name,
					Applicant_Last_Name: this.application.clientInfo.Applicant_Last_Name,
					Applicant_Phone: this.application.clientInfo.Applicant_Phone,
					Applicant_Email: this.application.clientInfo.Applicant_Email,
					Applicant_Date_of_Birth: this.application.clientInfo
						.Applicant_Date_of_Birth,
					Applicant_Address_Text: this.application.clientInfo
						.Applicant_Address_Text,
					Applicant_Is_NZ_Resident: this.application.clientInfo
						.Applicant_Is_NZ_Resident,
					Applicant2_First_Name: this.application.clientInfo
						.Applicant2_First_Name,
					Applicant2_Last_Name: this.application.clientInfo.Applicant2_Last_Name,
					Applicant2_Phone: this.application.clientInfo.Applicant2_Phone,
					Applicant2_Date_of_Birth: this.application.clientInfo
						.Applicant2_Date_of_Birth,
					Applicant2_Address_Text: this.application.clientInfo
						.Applicant2_Address_Text,
					Applicant2_Is_NZ_Resident: this.application.clientInfo
						.Applicant2_Is_NZ_Resident,

					Applicant_Unit_Number: this.application.clientInfo
						.Applicant_Address_Details.structured_address
						? this.application.clientInfo.Applicant_Address_Details
							.structured_address.unit
						: null,
					Applicant_Street_Number: this.application.clientInfo
						.Applicant_Address_Details.structured_address
						? this.application.clientInfo.Applicant_Address_Details
							.structured_address.street_number
						: null,
					Applicant_Situation_Number: this.application.clientInfo
						.Applicant_Address_Details.structured_address
						? this.application.clientInfo.Applicant_Address_Details
							.structured_address.situation_number
						: null,
					Applicant_Street_Name: this.application.clientInfo
						.Applicant_Address_Details.structured_address
						? this.application.clientInfo.Applicant_Address_Details
							.structured_address.street_name
						: null,
					Applicant_Street_Type: this.application.clientInfo
						.Applicant_Address_Details.structured_address
						? this.application.clientInfo.Applicant_Address_Details
							.structured_address.road_type
						: null,
					Applicant_Suburb: this.application.clientInfo.Applicant_Address_Details
						.structured_address
						? this.application.clientInfo.Applicant_Address_Details
							.structured_address.suburb
						: null,
					Applicant_Town: this.getTown("clientInfo", "Applicant_Address_Details"),
					Applicant_Region: this.application.clientInfo.Applicant_Address_Details
						.structured_address
						? this.application.clientInfo.Applicant_Address_Details
							.structured_address.region
						: null,
					Applicant_Postal_Code: this.application.clientInfo
						.Applicant_Address_Details.structured_address
						? this.application.clientInfo.Applicant_Address_Details
							.structured_address.postcode
						: null,
					Applicant_Country: this.application.clientInfo.Applicant_Address_Details
						.structured_address
						? this.application.clientInfo.Applicant_Address_Details
							.structured_address.country
						: null,
					Applicant_Address_Latitude: this.application.clientInfo
						.Applicant_Address_Details.location
						? this.application.clientInfo.Applicant_Address_Details.location
							.wgs84_lat
						: null,
					Applicant_Address_Longitude: this.application.clientInfo
						.Applicant_Address_Details.location
						? this.application.clientInfo.Applicant_Address_Details.location
							.wgs84_lon
						: null,

					Applicant2_Unit_Number: this.application.clientInfo
						.Applicant2_Address_Details.structured_address
						? this.application.clientInfo.Applicant2_Address_Details
							.structured_address.unit
						: null,
					Applicant2_Street_Number: this.application.clientInfo
						.Applicant2_Address_Details.structured_address
						? this.application.clientInfo.Applicant2_Address_Details
							.structured_address.street_number
						: null,
					Applicant2_Situation_Number: this.application.clientInfo
						.Applicant2_Address_Details.structured_address
						? this.application.clientInfo.Applicant2_Address_Details
							.structured_address.situation_number
						: null,
					Applicant2_Street_Name: this.application.clientInfo
						.Applicant2_Address_Details.structured_address
						? this.application.clientInfo.Applicant2_Address_Details
							.structured_address.street_name
						: null,
					Applicant2_Street_Type: this.application.clientInfo
						.Applicant2_Address_Details.structured_address
						? this.application.clientInfo.Applicant2_Address_Details
							.structured_address.road_type
						: null,
					Applicant2_Suburb: this.application.clientInfo
						.Applicant2_Address_Details.structured_address
						? this.application.clientInfo.Applicant2_Address_Details
							.structured_address.suburb
						: null,
					Applicant2_Town: this.getTown(
						"clientInfo",
						"Applicant2_Address_Details"
					),
					Applicant2_Region: this.application.clientInfo
						.Applicant2_Address_Details.structured_address
						? this.application.clientInfo.Applicant2_Address_Details
							.structured_address.region
						: null,
					Applicant2_Postal_Code: this.application.clientInfo
						.Applicant2_Address_Details.structured_address
						? this.application.clientInfo.Applicant2_Address_Details
							.structured_address.postcode
						: null,
					Applicant2_Country: this.application.clientInfo
						.Applicant2_Address_Details.structured_address
						? this.application.clientInfo.Applicant2_Address_Details
							.structured_address.country
						: null,
					Applicant2_Address_Latitude: this.application.clientInfo
						.Applicant2_Address_Details.location
						? this.application.clientInfo.Applicant2_Address_Details.location
							.wgs84_lat
						: null,
					Applicant2_Address_Longitude: this.application.clientInfo
						.Applicant2_Address_Details.location
						? this.application.clientInfo.Applicant2_Address_Details.location
							.wgs84_lon
						: null,
					Contact_Applicant2_Authorized: this.application.clientInfo
						.contactApplicant2Authorized,
					Has_Additional_Applicant: this.application.clientInfo
						.hasSecondApplicant,
					Interest_Repayment: this.application.loanData.monthly_interest,
					PI_Monthly_Repayment: this.application.loanData.monthly_repayment,
					Has_Accountant_Included: this.application.clientInfo
						.hasAccountantIncluded,
					Accountant_Name: this.application.clientInfo.Accountant_Name,
					Accountant_Firm: this.application.clientInfo.Accountant_Firm,
					Accountant_Phone: this.application.clientInfo.Accountant_Phone,
					Accountant_Email: this.application.clientInfo.Accountant_Email,
					Contact_Accountant_Authorized: this.application.clientInfo
						.contactAccountantAuthorized,
				};
				this.connectToApiAndSend(data_to_send);
			},
			connectToApiAndSend: function connectToApiAndSend(data) {
				this.saveDataRequests.push(
					fetch(this.api_url, {
						method: "POST",
						body: JSON.stringify(data),
						headers: this.call_headers,
					})
						.then(function (response) {
							if (response.ok) {
								return response.json();
							}
							return Promise.reject(response);
						})
						.catch(function (error) {
							console.warn("Something went wrong.", error);
						})
				);
			},
			sendPageTrackingData: function sendPageTrackingData(stepNumber) {
				if (!this.guid) return false;
				var data_to_send = {
					guid: this.guid,
					Last_Page_Visited: "",
					Online_Status: "",
				};
				switch (stepNumber) {
					case 1:
						data_to_send.Last_Page_Visited = "check-eligibility";
						break;
					case 2:
						data_to_send.Last_Page_Visited = "farm-details";
						data_to_send.Online_Status = "Incomplete Farm Details";
						break;
					case 3:
						data_to_send.Last_Page_Visited = "finance-details";
						data_to_send.Online_Status = "Incomplete Finance Details";
						break;
					case 4:
						data_to_send.Last_Page_Visited = "your-details";
						data_to_send.Online_Status = "Incomplete Your Details";
						break;
					case 5:
						data_to_send.Last_Page_Visited = this.product === "dairy" ? "dd-declined" : "declined";
						if (this.application.farmInfo.Farm_Address_Text)
							data_to_send.Online_Status = "Submitted";
						else data_to_send.Online_Status = "Declined LVR";
						break;
					case 6:
						data_to_send.Last_Page_Visited = this.product === "dairy" ? "dd-referred" : "referred";
						data_to_send.Online_Status = "Submitted";
						break;
					case 7:
						data_to_send.Last_Page_Visited = this.product === "dairy" ? "dd-success" : "success";
						data_to_send.Online_Status = "Submitted";
						break;
					case 8:
						data_to_send.Last_Page_Visited = this.product === "dairy" ? "dd-approved" : "approved";
						data_to_send.Online_Status = "Submitted";
						break;

					default:
						return false;
				}
				this.connectToApiAndSend(data_to_send);
			},

			checkEligibility: function checkEligibility() {
				if (this.guid) {
					var eligibility_check_url = this.api_url + "/eligibility/" + this.guid;
					var self = this;
					Promise.all(this.saveDataRequests).then(function () {
						fetch(eligibility_check_url, {
							method: "GET",
							headers: self.call_headers,
						})
							.then(function (response) {
								if (response.ok) {
									return response.json();
								}
								return Promise.reject(response);
							})
							.then(function (data) {
								if (data.Data && data.Data.Eligibility) {
									self.eligibility = data.Data.Eligibility;
									self.redirectAfterEligibilityCheck();
									window.scrollTo(0, 0);
								}
							})
							.catch(function (error) {
								console.warn("Something went wrong.", error);
							});
					});
				}
			},
			redirectAfterEligibilityCheck: function redirectAfterEligibilityCheck() {
				switch (this.eligibility) {
					case "Eligible":
						this.currentStep = 2;
						this.$router.push({ name: "farm-details" });
						break;
					case "Declined":
						this.currentStep = 5;
						this.$router.push({ name: this.product === "dairy" ? "dd-declined" : "declined" });
						console.log("Declined");
						break;
					case "Referred":
						this.currentStep = 2;
						// this.$router.push({ name: 'farm-details' })
						console.log("Referred");
						break;
					default:
						break;
				}
			},
			redirectAfterSubmission: function redirectAfterSubmission() {
				// this.currentStep = 6; // Referred page
				switch (this.eligibility) {
					case "Eligible":
					case "Approved":
						this.currentStep = 7;
						this.$router.push({ name: this.product === "dairy" ? "dd-success" : "success" });
						break;
					case "Declined":
						this.currentStep = 5;
						this.$router.push({ name: this.product === "dairy" ? "dd-declined" : "declined" });
						console.log("Declined");
						break;
					case "Referred":
						this.currentStep = 6;
						this.$router.push({ name: this.product === "dairy" ? "dd-referred" : "referred" });
						console.log("Referred");
						break;
					case "ConditionalApproved":
						this.currentStep = 8;
						this.$router.push({ name: this.product === "dairy" ? "dd-approved" : "approved" });
						break;
					default:
						break;
				}
			},
			submitApplication: function submitApplication() {
				const process_url = this.api_url + "/process/" + this.guid;
				this.loading = true;
				var self = this;
				Promise.all(this.saveDataRequests).then(function () {
					fetch(process_url, {
						method: "GET",
						headers: self.call_headers,
					})
						.then(function (response) {
							if (response.ok) {
								return response.json();
							}
							return Promise.reject(response);
						})
						.then(function (data) {
							if (data.Data && data.Data.Eligibility) {
								self.eligibility = data.Data.Eligibility;
								self.redirectAfterSubmission();
								window.scrollTo(0, 0);
								self.loading = false;
							}
						})
						.catch(function (error) {
							console.warn("Something went wrong.", error);
							self.redirectAfterSubmission(); // TEMPORARY here
						});
				});
			},
			getTownOrSuburb: function getTownOrSuburb(str_address) {
				if (str_address.town) {
					return str_address.town;
				} else {
					return str_address.suburb;
				}
			},
			getTown: function getTown(section_name, field_name) {
				if (typeof section_name !== "string" || typeof field_name !== "string")
					return null;
				var info = this.application[section_name];
				if (!info) return null;
				var str_address = info[field_name].structured_address;
				return str_address ? this.getTownOrSuburb(str_address) : null;
			},
			parseLocationString: function parseLocationString(str) {

				//console.log("AppContent.vue QS=" + str + " (product=" + this.product + ") (appName=" + this.appName + ")");

				if (str.indexOf("purpose=") > -1) {
					if (str.indexOf("=refinance") > -1) {
						this.application.purpose = "refinance";
					} else if (str.indexOf("=both") > -1) {
						this.application.purpose = "both";
					}
				}
				// Uncomment if we need to handle amount passed from corporate site
				// if(str.indexOf('amount=') > -1) {
				//   var matches = str.match(/amount=(\d+)/)
				//   if(matches.length > 1) {
				//     if(this.application.purpose === 'refinance') {
				//       this.application.loanData.Farm_Refinance_Amount = parseInt(matches[1],10)
				//     } else {
				//       this.application.loanData.Farm_Purchase_Price = parseInt(matches[1],10)
				//     }
				//   }
				// }
			},
		},
		created: function () {
			this.application.product = this.product

			this.api_url = process.env.API_URL;
			this.queryString = window.location.search;
			if (window.location.search) {
				this.parseLocationString(window.location.search);
			}
			//#pjw set default dynamically (different for S&B and Dairy)
			this.application.farm_type =
				this.application.product === "dairy" ? "dairy" : "beef";
		},
	};
</script>
